export const maxWidth = 1170;

export const horizontalSpacing = {
  phone: 14,
  tablet: 20,
  desktop: 20,
};

export const topSpacing = {
  phone: 20,
  tablet: 40,
};
